import { RouteRecordRaw } from "vue-router";
import InitView from "@/apps/credit-line/views/InitView.vue";
import AddOnActivationView from "@/apps/credit-line/views/AddOn/AddOnActivationView.vue";
import CreditLineWithdrawView from "@/apps/credit-line/views/Withdraw/CreditLineWithdrawView.vue";
import CreditLineWithdrawDefrostView from "@/apps/credit-line/views/Withdraw/CreditLineWithdrawDefrostView.vue";
import CreditLineRegistrationView from "@/apps/credit-line/views/CreditLineRegistrationView.vue";
import CreditLinePaymentWizardView from "@/apps/credit-line/views/CreditLinePaymentWizardView.vue";
import CreditLinePaymentDetailsView from "@/apps/credit-line/views/CreditLinePaymentDetailsView.vue";
import CreditLineTransactionsHistoryView from "@/apps/credit-line/views/CreditLineTransactionsHistoryView.vue";
import CreditLineHelpView from "@/apps/credit-line/views/HelpView.vue";
import CreditLineCancelView from "@/apps/credit-line/views/CreditLineCancelView.vue";
import CreditLineWithdrawInstructionsView from "@/apps/credit-line/views/Withdraw/CreditLineWithdrawInstructionsView.vue";
import CreditLineWithdrawalUnavailableView from "@/apps/credit-line/views/Withdraw/WithdrawalUnavailableView.vue";
import CreditLineWithdrawalFrozenView from "@/apps/credit-line/views/Withdraw/WithdrawalFrozenView.vue";
import HistoricalBalancesView from "@/apps/credit-line/views/HistoricalBalancesView.vue";
import CreditLineStatementDetailsView from "@/apps/credit-line/views/CreditLineStatementDetailsView.vue";
import WithdrawalResultView from "@/apps/credit-line/views/Withdraw/WithdrawalResultView.vue";
import WithdrawalRejectionView from "@/apps/credit-line/views/Withdraw/WithdrawalRejectionView.vue";
import AccountVerificationRequestView from "@/apps/credit-line/views/AccountVerificationRequestView.vue";
import CreditLineSurveyView from "@/apps/credit-line/views/CreditLineSurveyView.vue";
import UnlinkBankAccountSurveyResultView from "@/apps/credit-line/views/UnlinkBankAccountSurveyResultView.vue";
import CreditLineOptOutView from "@/apps/credit-line/views/CreditLineOptOutView.vue";
import CreditCardActivationView from "@/apps/credit-line/views/CreditCard/CreditCardActivationView.vue";
import CreditCardActivationResultView from "@/apps/credit-line/views/CreditCard/CreditCardActivationResultView.vue";
import CreditCardDetailsView from "@/apps/credit-line/views/CreditCard/CreditCardDetailsView.vue";
import CreditCardShippingAddressView from "@/apps/credit-line/views/CreditCard/CreditCardShippingAddressView.vue";
import CreditCardTransactionCalculator from "@/apps/credit-line/views/CreditCard/CreditCardTransactionCalculator.vue";
import CreditLineResultView from "@/apps/credit-line/views/CreditLineResultView.vue";
import CreditLineErrorView from "@/apps/credit-line/views/CreditLineErrorView.vue";
import CreditCardPinChangeView from "@/apps/credit-line/views/CreditCard/CreditCardPinChangeView.vue";
import CreditCardPinChangeResultView from "@/apps/credit-line/views/CreditCard/CreditCardPingChangeResultView.vue";
import CardIntroTutorialView from "@/apps/credit-line/views/CreditCard/CardIntroTutorialView.vue";
import LimitIncreaseView from "@/apps/credit-line/views/Offers/LimitIncreaseView.vue";
import NonEligibleView from "@/apps/credit-line/views/Invitation/NonEligibleView.vue";
import CardBenefitsView from "@/apps/credit-line/views/CreditCard/CardBenefitsView.vue";
import CreditLineCheckCreditPullView from "@/apps/credit-line/views/CreditLineCheckCreditPullView.vue";
import CreditCardConfirmDelete from "@/apps/credit-line/views/CreditCard/CreditCardConfirmDeleteView.vue";
import CreditCardConfirmCreate from "@/apps/credit-line/views/CreditCard/CreditCardConfirmCreateView.vue";
import CreditLineDiscoveryView from "@/apps/credit-line/views/CreditLineDiscoveryView.vue";
import OnboardingSliderView from "@/apps/credit-line/views/OnboardingSliderView.vue";
import TransactionReportsView from "@/apps/credit-line/views/Transactions/TransactionReportsView.vue";
import CreditCardTransitionView from "@/apps/credit-line/views/CreditCard/CreditCardTransitionView.vue";
import CreditCardUserDataCaptureView from "@/apps/credit-line/views/CreditCard/CreditCardUserDataCaptureView.vue";
import PacmanOnboardingView from "@/apps/credit-line/views/Invitation/PacmanOnboardingView.vue";
import PaymentFaqsView from "@/apps/credit-line/views/PaymentFaqsView.vue";
import { getDeviceTagHelper } from "@/apps/credit-line/helpers/getDeviceTag.helper";
import TransitionalView from "@/apps/credit-line/views/SimultaneousJoinLine/TransitionalView.vue";
import { AndroidFinishLoadingHelper } from "@/apps/credit-line/helpers/androidFinishLoading.helper";
import CardOverview from "@/apps/credit-line/components/CreditCard/CardOverview.vue";
import { isAndroid } from "@/apps/credit-line/helpers/platformChecker.helper";
import JointLoanLineNotificationView from "@/apps/credit-line/views/Invitation/JointLoanLineNotificationView.vue";
import YourLineComingSoonView from "@/apps/credit-line/views/YourLineComingSoonView.vue";
import ReportCardSteps from "@/apps/credit-line/components/CreditCard/ReportCard/views/ReportCardSteps.vue";
import { checkZeroLimitGuard } from "@/apps/credit-line/helpers/credit-limit.helper";
import LimitIncreaseAcceptanceView from "@/apps/credit-line/views/Offers/LimitIncreaseAcceptanceView.vue";
import InputWithdrawalAmountView from "@/apps/credit-line/views/Withdraw/InputWithdrawalAmountView.vue";
import IdentityVerificationView from "@/apps/credit-line/views/Withdraw/IdentityVerificationView.vue";
import AmlSurveyView from "@/apps/credit-line/views/Withdraw/AmlSurveyView.vue";
import { creditLineTranslationGuard } from "@/router/translationGuards";
import JointLoanLineLimitIncreaseView from "@/apps/credit-line/views/Offers/JointLoanLineLimitIncreaseView.vue";
import UseYourCardView from "@/apps/credit-line/views/UseYourCardView.vue";
import NotAllowedView from "@/apps/credit-line/views/CreditCard/NotAllowedView.vue";
import PromotionInlineView from "@/apps/credit-line/views/PromotionInlineView.vue";

const enableRUMMeta = { enableRUM: true };

const phoneFinanceDeviceDetailsGuard = (): void => {
  AndroidFinishLoadingHelper();
  window.location.href = `${
    process.env.VUE_APP_PAYJOY_HOST
  }/device-details.php?deviceTag=${getDeviceTagHelper()}`;
};

const basePath =
  process.env.VUE_APP_BUILD_TYPE === "credit-line" ? "" : "/creditline";

const routes: Array<RouteRecordRaw> = [
  {
    path: `${basePath}/init`,
    name: "CreditLineInitView",
    component: InitView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/withdraw`,
    name: "CreditLineWithdrawView",
    beforeEnter: [checkZeroLimitGuard, creditLineTranslationGuard],
    component: CreditLineWithdrawView,
  },
  {
    path: `${basePath}/withdraw/defrost`,
    name: "CreditLineWithdrawDefrostView",
    component: CreditLineWithdrawDefrostView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/discovery`,
    name: "CreditLineOnBoardingView",
    redirect: (to) => ({ path: `${basePath}/init`, query: to.query }),
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/registration`,
    name: "CreditLineRegistrationView",
    component: CreditLineRegistrationView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/payment`,
    name: "CreditLinePaymentWizardView",
    component: CreditLinePaymentWizardView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/line-details`,
    name: "CreditLineLineDetailsView",
    redirect: { path: `${basePath}/transactions-history` },
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/weekly-payment-details`,
    name: "CreditLinePaymentDetailsView",
    component: CreditLinePaymentDetailsView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/transactions-history`,
    name: "CreditLineTransactionsHistoryView",
    component: CreditLineTransactionsHistoryView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/report-transaction/:debitId`,
    name: "CreditLineReportTransaction",
    component: TransactionReportsView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/help`,
    name: "CreditLineHelpView",
    component: CreditLineHelpView,
    beforeEnter: [
      creditLineTranslationGuard,
      // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
      (_, __, next) => {
        if (!isAndroid()) {
          next({ name: "CreditLinePaymentFaqs" });
        } else {
          next();
        }
      },
    ],
  },
  {
    path: `${basePath}/payment-faqs`,
    name: "CreditLinePaymentFaqs",
    component: PaymentFaqsView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/error`,
    name: "CreditLineErrorView",
    component: CreditLineErrorView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/api-error/display`,
    name: "CreditLineApiErrorDisplay",
    component: () =>
      import("@/apps/credit-line/views/CreditLineApiErrorDisplay.vue"),
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/cancel`,
    name: "CreditLineCancelView",
    component: CreditLineCancelView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/opt-out`,
    name: "CreditLineOptOutView",
    component: CreditLineOptOutView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/withdraw-instructions`,
    name: "CreditLineWithdrawInstructionsView",
    component: CreditLineWithdrawInstructionsView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/account-verification`,
    name: "CreditLineBankAccountVerification",
    component: AccountVerificationRequestView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/withdrawal-request`,
    name: "CreditLineWithdrawalRequest",
    component: WithdrawalResultView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/withdrawal-rejection`,
    name: "CreditLineWithdrawalRejection",
    component: WithdrawalRejectionView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/withdrawal-unavailable`,
    name: "CreditLineWithdrawalUnavailableView",
    component: CreditLineWithdrawalUnavailableView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/withdrawal-frozen`,
    name: "CreditLineWithdrawalFrozenView",
    component: CreditLineWithdrawalFrozenView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/historical-balances`,
    name: "HistoricalBalancesView",
    component: HistoricalBalancesView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/balance-details`,
    name: "BalanceDetailsView",
    component: CreditLineStatementDetailsView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/survey`,
    name: "SurveyView",
    component: CreditLineSurveyView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/survey/unlink-bank-account-result`,
    name: "UnlinkBankAccountSurveyResultView",
    component: UnlinkBankAccountSurveyResultView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/card/virtual`,
    name: "CreditCardVirtualView",
    redirect: { path: `${basePath}/card`, query: { defaultType: "VIRTUAL" } },
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/card/CardOverview`,
    name: "CardOverview",
    component: CardOverview,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/card`,
    name: "CreditCardView",
    beforeEnter: [checkZeroLimitGuard, creditLineTranslationGuard],
    component: CreditCardDetailsView,
  },
  {
    path: `${basePath}/card/transaction-calculator`,
    name: "CreditCardTransactionCalculator",
    component: CreditCardTransactionCalculator,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/card/shipment`,
    name: "CreditCardShippingAddressView",
    component: CreditCardShippingAddressView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/card/activation`,
    name: "CreditCardActivationView",
    component: CreditCardActivationView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/card/activation/result`,
    name: "CreditCardActivationResultView",
    component: CreditCardActivationResultView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/card/intro-tutorial`,
    name: "CardIntroTutorialView",
    component: CardIntroTutorialView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/card/details`,
    name: "CreditCardDetailsView",
    component: CreditCardDetailsView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/result`,
    name: "CreditLineResultView",
    component: CreditLineResultView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/card/discovery`,
    name: "CreditLineDiscoveryView",
    component: CreditLineDiscoveryView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/card/pin-change`,
    name: "CreditCardPinChangeView",
    component: CreditCardPinChangeView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/card/pin-change/result`,
    name: "CreditCardPinChangeResultView",
    component: CreditCardPinChangeResultView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/card/confirm-delete`,
    name: "CreditCardConfirmDeleteView",
    component: CreditCardConfirmDelete,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/card/confirm-create`,
    name: "CreditCardConfirmCreateView",
    component: CreditCardConfirmCreate,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/card/initial-transition`,
    name: "CreditCardTransitionView",
    component: CreditCardTransitionView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/card/user-data-capture`,
    name: "CreditCardUserDataCaptureView",
    component: CreditCardUserDataCaptureView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/limit-increase`,
    name: "LimitIncreaseView",
    component: LimitIncreaseView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/non-eligible`,
    name: "NonEligibleView",
    component: NonEligibleView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/new-ui-intro`,
    name: "OnboardingSliderView",
    component: OnboardingSliderView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/new-ui-intro`,
    name: "OnboardingSliderView",
    component: OnboardingSliderView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/card/benefits`,
    name: "CardBenefitsView",
    component: CardBenefitsView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/credit-pull`,
    name: "CheckCreditPullView",
    component: CreditLineCheckCreditPullView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/pacman-onboarding`,
    name: "PacmanOnboardingView",
    component: PacmanOnboardingView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: "/pf-device-details",
    name: "PhoneFinanceDeviceDetails",
    beforeEnter: [creditLineTranslationGuard, phoneFinanceDeviceDetailsGuard],
    component: {
      render: () => null,
    },
  },
  {
    path: `${basePath}/pf-device-details`,
    name: "PhoneFinanceDeviceDetails",
    beforeEnter: [
      creditLineTranslationGuard,
      (): void => {
        AndroidFinishLoadingHelper();
        window.location.href = `${
          process.env.VUE_APP_PAYJOY_HOST
        }/device-details.php?deviceTag=${getDeviceTagHelper()}`;
      },
    ],
    component: {
      render: () => null,
    },
  },
  {
    path: `${basePath}/simultaneous-join-line-welcome`,
    name: "SuperPacmanTransitionalView",
    component: TransitionalView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/joint-loan-line-welcome`,
    name: "JointLoanLineNotificationView",
    component: JointLoanLineNotificationView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/coming-soon`,
    name: "YourLineComingSoonView",
    component: YourLineComingSoonView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/report-card/:step`,
    name: "ReportCardSteps",
    component: ReportCardSteps,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/limit-increase-acceptance`,
    name: "LimitIncreaseAcceptanceView",
    component: LimitIncreaseAcceptanceView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/limit-increase-sign`,
    name: "LimitIncreaseSignView",
    component: JointLoanLineLimitIncreaseView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/input-withdrawal-amount`,
    name: "InputWithdrawalAmountView",
    component: InputWithdrawalAmountView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/identity-verification`,
    name: "IdentityVerificationView",
    component: IdentityVerificationView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/aml-survey`,
    name: "AmlSurveyView",
    component: AmlSurveyView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/add-on/activation`,
    name: "AddOnActivationView",
    component: AddOnActivationView,
    beforeEnter: [creditLineTranslationGuard],
  },
  {
    path: `${basePath}/card/not-available`,
    name: "CardNotAvailableView",
    component: NotAllowedView,
  },
  {
    path: `${basePath}/use-your-card`,
    name: "UseYourCardView",
    component: UseYourCardView,
  },
  {
    path: `${basePath}/inline-promotion`,
    name: "PromotionInlineView",
    component: PromotionInlineView,
  },
].map((route) => ({ ...route, meta: enableRUMMeta }));

export default routes;
